import { LoadingDirectiveModule } from '@shared/loading-directive/loading-directive.module';
import { NgModule } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { FuseNavigationModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { NavbarVerticalStyle1Component } from '@app/components-fuse/layout/components/navbar/vertical/style-1/style-1.component';
import {NgOptimizedImage} from "@angular/common";

@NgModule({
    declarations: [
        NavbarVerticalStyle1Component
    ],
  imports: [
    MatButtonModule,
    MatIconModule,

    FuseSharedModule,
    FuseNavigationModule,
    NgOptimizedImage,
    LoadingDirectiveModule
  ],
    exports     : [
        NavbarVerticalStyle1Component
    ]
})
export class NavbarVerticalStyle1Module
{
}
